import { AxiosResponse } from "axios";
import { api } from "./axios";

export interface Message {
  senderId: number;
  receiverId: number;
  text: string;
  sendAt: string;
  id: number;
}

export const MESSAGES = "messages";

export const getMessages = (
  senderId: number,
  receiverId: number,
): Promise<AxiosResponse<Message[]>> => {
  return api.get("/message/senderAndReceiver", {
    params: { senderId, receiverId },
  });
};

export const clearChat = (
  senderId: number,
  receiverId: number,
): Promise<AxiosResponse<Message[]>> => {
  return api.get("/message/clearChat", {
    params: { senderId, receiverId },
  });
};
